import { combineReducers } from "redux";
import report from "./report";
import priceList from "./price_list";
import symbol from "./symbol";
import candleStickReport from "./candle_stick_report";
import volumeReport from "./volume_report";
import foreignVolumeReport from "./foreign_volume_report";
import buySellReport from "./buy_sell_report";
const rootReducer = combineReducers({report, candleStickReport, volumeReport, priceList, symbol, foreignVolumeReport, buySellReport});   
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
